module.exports = __webpack_public_path__ + "img/card_ip_stipulation36.341ccf1d.svg";